import api from "./axios";

const BASE = "/payroll";

/** Multipart form for endpoints that accept an attachment. */
function toFormData(payload = {}, fileField = "attachment") {
  const form = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    if (key === fileField && value instanceof File) {
      form.append(fileField, value);
    } else if (Array.isArray(value)) {
      value.forEach((v) => form.append(`${key}[]`, v));
    } else {
      form.append(key, value);
    }
  });
  return form;
}

const MULTIPART = { headers: { "Content-Type": "multipart/form-data" } };
const BLOB = { responseType: "blob" };

/* --- Rider Expenses --- */
export const listRiderExpenses = (params = {}) => api.get(`${BASE}/expenses`, { params });
export const getRiderExpenseKpis = (params = {}) => api.get(`${BASE}/expenses/kpis`, { params });
export const createRiderExpense = (payload) =>
  api.post(`${BASE}/expenses`, toFormData(payload), MULTIPART);
export const updateRiderExpense = (id, payload) =>
  api.put(`${BASE}/expenses/${id}`, toFormData(payload), MULTIPART);
export const deleteRiderExpense = (id) => api.delete(`${BASE}/expenses/${id}`);
export const exportRiderExpenses = (params = {}) =>
  api.get(`${BASE}/expenses/export`, { params, ...BLOB });

/* --- EMI Management --- */
export const listEmiAgreements = (params = {}) => api.get(`${BASE}/emi`, { params });
export const getEmiKpis = (params = {}) => api.get(`${BASE}/emi/kpis`, { params });
export const createEmiAgreement = (payload) =>
  api.post(`${BASE}/emi`, toFormData(payload), MULTIPART);
export const updateEmiAgreement = (id, payload) =>
  api.put(`${BASE}/emi/${id}`, toFormData(payload), MULTIPART);
export const pauseEmiAgreement = (id) => api.put(`${BASE}/emi/${id}/pause`);
export const resumeEmiAgreement = (id) => api.put(`${BASE}/emi/${id}/resume`);
export const completeEmiAgreement = (id) => api.put(`${BASE}/emi/${id}/complete`);
export const forecloseEmiAgreement = (id, foreclosureReason) =>
  api.put(`${BASE}/emi/${id}/foreclose`, { foreclosureReason });
export const deleteEmiAgreement = (id) => api.delete(`${BASE}/emi/${id}`);
export const exportEmiAgreements = (params = {}) =>
  api.get(`${BASE}/emi/export`, { params, ...BLOB });
export const downloadEmiTemplate = () => api.get(`${BASE}/emi/template`, BLOB);
export const uploadEmiAgreements = (file, { expenseType, workType, project }) => {
  const form = new FormData();
  form.append("file", file);
  if (expenseType) form.append("expenseType", expenseType);
  if (workType) form.append("workType", workType);
  if (project) form.append("project", project);
  return api.post(`${BASE}/emi/upload`, form, MULTIPART);
};

/* --- EMI Installments (EMI KPI tab) --- */
export const listEmiInstallments = (params = {}) =>
  api.get(`${BASE}/emi/installments`, { params });
export const getEmiInstallmentKpis = (params = {}) =>
  api.get(`${BASE}/emi/installments/kpis`, { params });
export const processEmiInstallment = (id) =>
  api.put(`${BASE}/emi/installments/${id}/process`);
export const exportEmiInstallments = (params = {}) =>
  api.get(`${BASE}/emi/installments/export`, { params, ...BLOB });

/* --- NOC --- */
export const listNoc = (params = {}) => api.get(`${BASE}/noc`, { params });
export const createNoc = (payload) => api.post(`${BASE}/noc`, payload);
export const updateNoc = (id, payload) => api.put(`${BASE}/noc/${id}`, payload);
export const deleteNoc = (id) => api.delete(`${BASE}/noc/${id}`);
export const downloadNocPdf = (id) => api.get(`${BASE}/noc/${id}/pdf`, BLOB);
export const exportNoc = (params = {}) => api.get(`${BASE}/noc/export`, { params, ...BLOB });

/* --- Pledge --- */
export const listPledge = (params = {}) => api.get(`${BASE}/pledge`, { params });
export const createPledge = (payload) => api.post(`${BASE}/pledge`, payload);
export const updatePledge = (id, payload) => api.put(`${BASE}/pledge/${id}`, payload);
export const deletePledge = (id) => api.delete(`${BASE}/pledge/${id}`);
export const downloadPledgePdf = (id) => api.get(`${BASE}/pledge/${id}/pdf`, BLOB);
export const exportPledge = (params = {}) =>
  api.get(`${BASE}/pledge/export`, { params, ...BLOB });

/* --- Salary Status --- */
export const listSalaryStatus = (params = {}) => api.get(`${BASE}/salary-status`, { params });
export const getSalaryStatusKpis = (params = {}) =>
  api.get(`${BASE}/salary-status/kpis`, { params });
export const approveSalary = (id) => api.put(`${BASE}/salary-status/${id}/approve`);
export const rejectSalary = (id, rejectionReason) =>
  api.put(`${BASE}/salary-status/${id}/reject`, { rejectionReason });
export const exportSalaryStatus = (params = {}) =>
  api.get(`${BASE}/salary-status/export`, { params, ...BLOB });
